import { render, staticRenderFns } from "./UploaderModalComponent.vue?vue&type=template&id=3f598f52&scoped=true"
import script from "./UploaderModalComponent.vue?vue&type=script&lang=js"
export * from "./UploaderModalComponent.vue?vue&type=script&lang=js"
import style0 from "./UploaderModalComponent.vue?vue&type=style&index=0&id=3f598f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f598f52",
  null
  
)

export default component.exports